module.exports = __webpack_public_path__ + "static/img/inviteowns02.80a13392.png";